import styled from 'styled-components'
import PageCalling from 'src/components/common/PageCalling'
import { useParams } from 'react-router-dom'
import { JoinFormType, PramsKeys } from 'src/types/type'
import useAPI from 'src/hooks/useAPI'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import {
  PartnerListData,
  TelTypeState,
  uiData,
  uiVerifyStyle,
  RecoilStateList,
  TermsListState,
} from 'src/recoil/common'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { useEffect } from 'react'
import Banner from 'src/components/common/Banner'
import PhoneVerification from 'src/components/views/mkt04/PhoneVerification'
import Terms from 'src/components/views/mkt04/Terms'
import JoinSubmit from 'src/components/views/mkt05/JoinSubmit'
import Footer from 'src/components/views/mkt04/Footer'
import { convertTermsData } from 'src/service/join'
import useSubmitWithModal from 'src/hooks/useSubmitWithModal'
import { ModalContextProvider } from 'src/components/views/mkt04/Modal/provider'
import Modal from 'src/components/views/mkt04/Modal'
import {
  NoticeFeeText,
  NoticeText,
  NoticeWrap,
} from 'src/styles/styledcomponent/views/mkt04/JoinSubmit'
import { useToast } from 'src/hooks/useToast'
import Toast from 'src/components/views/mkt04/ToastPopup'
import { FormProvider, useForm } from 'react-hook-form'
import { landing_greenp } from 'src/service/utils/greenp'
import { useTrackingPage } from 'src/hooks/useTrackingPage'
import VulnerableCheckModal from 'src/components/views/join/VulnerableCheckModal'

const Mkt05Inner = () => {
  const { isShow, message, openToast } = useToast(2200)
  const { pcode, telecom } = useParams<PramsKeys>()
  const submit = useSubmitWithModal(pcode ?? '', { openToast })
  const termsApi = useAPI('requestTermsList')
  const { cashSpace } = useRecoilValue(uiVerifyStyle)
  const { CertNum, Timeout } = useRecoilValue(RecoilStateList)

  const setTermsListState = useSetRecoilState(TermsListState)
  const [partnerData, setPartnerData] = useRecoilState(PartnerListData)
  const setTelType = useSetRecoilState(TelTypeState)
  const { RefElement, onMoveToElement, RefInput } = useMoveScroll()
  const setUiData = useSetRecoilState(uiData)
  const { form, isGreenpTracking } = useTrackingPage()

  //Greenp 추적 스크립트 추가(251217)
  useEffect(() => {
    if (!isGreenpTracking) return
    if ((window as any).__GREENP_LANDING_INIT__) return
    ;(window as any).__GREENP_LANDING_INIT__ = true
    landing_greenp()
  }, [form, isGreenpTracking])

  const { data: getTermsData, isSuccess, isLoading } = termsApi?.useSetQuery({ PCode: pcode })

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      const telecomNumber = telecom ? Number(telecom) : 0
      setTelType(telecomNumber)
      setTermsListState(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data?.Partner.UiData)))
    }
    // eslint-disable-next-line
  }, [
    isSuccess,
    isErrorPartner,
    getTermsData?.Body,
    setPartnerData,
    setTermsListState,
    setTelType,
    setUiData,
  ])

  const isCertFilled = (CertNum?.length ?? 0) === 4

  return (
    <Mkt05Wrap $isBtnChange={isCertFilled && Timeout > 0}>
      <PageCalling active={isLoading} />
      {isSuccess && (
        <>
          <Banner RefElement={RefElement} />
          <>
            <PhoneVerification
              onMoveToElement={onMoveToElement}
              RefInput={RefInput}
              submit={submit}
              openToast={openToast}
            />
            <SwitchComp>
              {!isErrorPartner && <Terms />}
              <JoinSubmit submit={submit} />
            </SwitchComp>
            <NoticeWrap>
              <NoticeFeeText
                cashSpace={cashSpace}
                fontColor={partnerData.FontColor}
                fontSize={partnerData.FontSize}
                dangerouslySetInnerHTML={{ __html: partnerData.NotiContent }}
              />
              <NoticeText cashSpace={cashSpace} fontSize={partnerData.FontSize}>
                본 서비스는 통신3사 제휴 부가서비스로 (주)데이터유니버스에서 운영합니다.
              </NoticeText>
            </NoticeWrap>
            <Footer />
          </>
        </>
      )}
      <Toast show={isShow} message={message} />
      <VulnerableCheckModal submit={submit} />
    </Mkt05Wrap>
  )
}

export default function Index() {
  const methods = useForm<JoinFormType>({
    mode: 'onSubmit',
    defaultValues: {
      PNumber: '',
      TranID: '',
      ApprovalNumber: '',
    },
  })
  return (
    <FormProvider {...methods}>
      <ModalContextProvider>
        <Mkt05Inner />
        <Modal />
      </ModalContextProvider>
    </FormProvider>
  )
}

const Mkt05Wrap = styled.div<{ $isBtnChange: boolean }>`
  max-width: 492px;
  margin: 0 auto;
  background-color: #fff;

  & .btn_signup {
    img {
      display: none;
    }
  }
`

const SwitchComp = styled.div`
  display: flex;
  flex-direction: column;
`
